var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from "../../../pages/modules/base-entity";
import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { Router } from "aurelia-router";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { RouterConstants } from "../../../../configuration/router.constants";
import { I18N } from "aurelia-i18n";
import { StepEnum } from "../../../../models/modules/lotteryplatofrm.models";
import { GamePlayerClientService } from "../../../../services/modules/game-player-client.service";
import { PlayerBasicMeta } from "./steps/player-basic-meta";
import { PlayerChangeLog } from "./steps/player-changelog";
import { Guid } from "../../../../utilities/guid";
import { GamePlayerTicketLines } from "./steps/player-ticket-lines";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { PlayerKyc } from "./steps/player-kyc";
import { PlayerIpAddressLog } from "./steps/player-ip-address-log";
import { PlayerTransactions } from "./steps/player-transactions";
import { LotteryPlatformClaims } from "../../../../constants/modules/lotteryplatform.claims";
import { PlayerDetails } from "./steps/player-details";
import { GamePlayerTicketDraws } from "./steps/player-ticket-draws";
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player(dialogClientService, router, bindingEngine, notificationService, eventAggregator, i18N, gamePlayerClientService, playerDetails, userClaimsService, gamePlayerBasicMeta, playerKyc, playerIpAddressLog, playerChangeLog, gamePlayerTickerLines, gamePlayerTickerDraws, playerTransactions) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.gamePlayerClientService = gamePlayerClientService;
        _this.playerDetails = playerDetails;
        _this.userClaimsService = userClaimsService;
        _this.gamePlayerBasicMeta = gamePlayerBasicMeta;
        _this.playerKyc = playerKyc;
        _this.playerIpAddressLog = playerIpAddressLog;
        _this.playerChangeLog = playerChangeLog;
        _this.gamePlayerTickerLines = gamePlayerTickerLines;
        _this.gamePlayerTickerDraws = gamePlayerTickerDraws;
        _this.playerTransactions = playerTransactions;
        _this.activityLogEntitiesSave = [EntityTypes.Player];
        return _this;
    }
    Player.prototype.activate = function (params, navigationInstruction) {
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    Player.prototype.attached = function () {
        var _this = this;
        var id = this.getItemId();
        if (id) {
            this.gamePlayerClientService.getGamePlayerStats(id)
                .then(function (x) {
                _this.stats = x;
            }).catch(function (e) { return _this.notificationService.show(_this.i18N.tr('error-text') + "!", "Error loading stats for player", NotificationType.Error); });
        }
        return _super.prototype.attached.call(this);
    };
    Object.defineProperty(Player.prototype, "defaultGamePlayer", {
        get: function () {
            return {
                gamePlayerId: null,
                token: null,
                brandId: null,
                playerId: null,
                iPAddress: null,
                lastActive: null,
                countryId: null,
                currencyCode: null,
                playerLimit: null,
                createdDate: null,
                languageCode: null,
                email: null,
                balance: null,
                playerStatusId: null,
                tags: null,
                entityType: EntityTypes.Player,
                identifier: Guid.generateGuid()
            };
        },
        enumerable: false,
        configurable: true
    });
    Player.prototype.getSteps = function () {
        return [
            {
                title: this.i18N.tr("game-player-basic-meta"),
                step: StepEnum.GamePlayerBasicMeta,
                vm: this.gamePlayerBasicMeta,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.PlayerBasicMeta),
                view: "../../app/admin/player/steps/player-basic-meta.html"
            },
            {
                title: this.i18N.tr("ticket-lines"),
                step: StepEnum.GamePlayerTicketLines,
                vm: this.gamePlayerTickerLines,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.PlayerTicketLines),
                view: "../../app/admin/player/steps/player-ticket-lines.html"
            },
            {
                title: this.i18N.tr("ticket-draws"),
                step: StepEnum.GamePlayerTicketDraws,
                vm: this.gamePlayerTickerDraws,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.PlayerTicketDraws),
                view: "../../app/admin/player/steps/player-ticket-draws.html"
            },
            {
                title: this.i18N.tr("game-player-transactions"),
                step: StepEnum.GamePlayerTransactions,
                vm: this.playerTransactions,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.PlayerTransactions),
                view: "../../app/admin/player/steps/player-transactions.html"
            },
            {
                title: this.i18N.tr("change-log"),
                step: StepEnum.GamePlayerChangeLog,
                vm: this.playerChangeLog,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.PlayerChangeLog),
                view: "../../app/admin/player/steps/player-changelog.html"
            },
            {
                title: this.i18N.tr("ip-address-log"),
                step: StepEnum.GamePlayerIpAddressLog,
                vm: this.playerIpAddressLog,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.PlayerIpAddressLog),
                view: "../../app/admin/player/steps/player-ip-address-log.html"
            },
            {
                title: this.i18N.tr("kyc"),
                step: StepEnum.GamePlayerKYC,
                vm: this.playerKyc,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.PlayerKyc),
                view: "../../app/admin/player/steps/player-kyc.html"
            }
        ].concat(this._params.isAgent ? [
            {
                title: this.i18N.tr("details"),
                step: StepEnum.GamePlayerDetails,
                vm: this.playerDetails,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.PlayerKyc),
                view: "../../app/admin/player/steps/player-details.html"
            }
        ] : []);
    };
    // Inherited
    Player.prototype.getItem = function (id) {
        var request = { id: id };
        return this.gamePlayerClientService.getGamePlayer(request);
    };
    Player.prototype.getItemId = function () {
        return this.item.gamePlayerId;
    };
    Player.prototype.getEntityType = function () {
        return EntityTypes.Player;
    };
    Player.prototype.beforeSave = function (skipValidation, resolve) {
        this.item.tags = this.gamePlayerBasicMeta.tagsList.join(",");
        resolve(true);
    };
    Player.prototype.saveItem = function (id, changes) {
        var request = { id: id, changes: changes };
        return this.gamePlayerClientService.save(request);
    };
    Player.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageLottery;
    };
    Player.prototype.initializeItemForCreate = function () {
        return this.defaultGamePlayer;
    };
    Player.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListLotteries;
    };
    Player = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService,
            Router, BindingEngine, NotificationClientService,
            EventAggregator, I18N, GamePlayerClientService, PlayerDetails,
            UserClaimsService, PlayerBasicMeta, PlayerKyc, PlayerIpAddressLog,
            PlayerChangeLog, GamePlayerTicketLines, GamePlayerTicketDraws, PlayerTransactions])
    ], Player);
    return Player;
}(BaseEntity));
export { Player };
